/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Onboarding_DescriptionInputs */

const en_meta_onboarding_description = /** @type {(inputs: Meta_Onboarding_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A quick setup to tailor Listening to how you want to listen.`)
};

const es_meta_onboarding_description = /** @type {(inputs: Meta_Onboarding_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una configuración rápida para adaptar Listening a cómo quieres escuchar.`)
};

/**
* | output |
* | --- |
* | "A quick setup to tailor Listening to how you want to listen." |
*
* @param {Meta_Onboarding_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_onboarding_description = /** @type {((inputs?: Meta_Onboarding_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Onboarding_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_onboarding_description(inputs)
	return en_meta_onboarding_description(inputs)
});